import React, { useMemo } from 'react';
import { getNavItems } from './navigation/navItems';
import { useLanguage } from '../contexts/LanguageContext';

interface BottomNavProps {
  value: number;
  onChange: (index: number) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ value, onChange }) => {
  const { t } = useLanguage();
  const navItems = useMemo(() => getNavItems(t), [t]);

  return (
    <nav className="m3-navbar" aria-label={t.nav.ariaBottomNav}>
      {navItems.map((item, idx) => {
        const active = value === idx;
        return (
          <button
            key={item.path}
            type="button"
            className="m3-nav-item"
            aria-current={active ? 'true' : 'false'}
            onClick={() => onChange(idx)}
          >
            <span className="m3-nav-pill">{active ? item.iconFilled : item.icon}</span>
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
